class Resultado {
    rows = [];

    constructor(json) {
        this.columnNames = json.columnNames;
        this.rows = json.rows.map((row) => {
            var newRow = {};
            for (var i = 0; i < this.columnNames.length; i++) {
                var value = row[i];
                var cType = json.columnClasses[i];
                /*
                if (cType === "java.sql.Date" && value !== null) {
                    try {
                        //value = Date.parse(value);
                    } catch (ex) { }
                }
                */
                newRow[this.columnNames[i]] = value;
            }
            return newRow;
        })
    }


}

export default Resultado;